import { Grid, Heading } from '@zappyrent/hundop';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { StyledParagraph } from './DiscoverZappyrent.styles';

const DiscoverZappyrentText = (): JSX.Element => {
  const { t } = useTranslation('product');

  return (
    <Grid container>
      <Heading
        charSpacing="-0.48px"
        tag="h2"
        sm="24px"
        md="24px"
        lg="24px"
        variant="secondary"
      >
        <Trans i18nKey="discoverZappyrent2" t={t} />
      </Heading>
      <StyledParagraph>
        <Trans i18nKey="discoverZappyrent3" t={t} />
      </StyledParagraph>
    </Grid>
  );
};

export default DiscoverZappyrentText;
